import { render } from "./ArticlesPage.vue?vue&type=template&id=187c491d&scoped=true"
import script from "./ArticlesPage.vue?vue&type=script&lang=js"
export * from "./ArticlesPage.vue?vue&type=script&lang=js"

import "./ArticlesPage.vue?vue&type=style&index=0&id=187c491d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187c491d"]])

export default __exports__